module.exports = __webpack_public_path__ + "img/expired-token.31daa8a7.png";